// The legacy build: the modern one uses JavaScript newer than Chrome 140 has (Map's
// getOrInsertComputed), and draws nothing there.
import worker from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';

/** How much larger than its own size the page is drawn: a scan's small print stays readable. */
const SCALE = 2;

/**
 * A PDF's first page drawn as a PNG with pdf.js: a scan has no words of its own, so its picture
 * is what the OCR reads. pdf.js loads only when one is drawn.
 */
export async function firstPage(url: string): Promise<Blob> {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
  pdfjs.GlobalWorkerOptions.workerSrc = worker;
  const pdf = await pdfjs.getDocument({ url }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: SCALE });
  const canvas = document.createElement('canvas');
  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  await page.render({ canvas, viewport }).promise;
  return new Promise((resolve, reject) => {
    canvas.toBlob((png) => {
      if (png) resolve(png);
      else reject(new Error('the page was not drawn'));
    }, 'image/png');
  });
}
